import { Box, Typography } from "@mui/material";

const MainAreaSection = ({ title, children, width, style }) => {
  const containerStyle = {
    width: width || "100%",
    display: "flex",
    flexDirection: "column",
    ...style,
  };
  const titleStyle = {
    mb: "1rem",
    fontSize: "1.25rem",
    fontWeight: 800,
  };
  const contentStyle = { flex: 1 };

  return (
    <Box sx={containerStyle}>
      <Typography variant="h3" sx={titleStyle}>
        {title}
      </Typography>
      <Box sx={contentStyle}>{children}</Box>
    </Box>
  );
};

export default MainAreaSection;
